import { ref } from 'vue'

// Shared reactive orientation state
const isLandscape = ref<boolean>(
  typeof window !== 'undefined' ? window.matchMedia('(orientation: landscape)').matches || window.innerWidth > window.innerHeight || Math.min(window.innerWidth, window.innerHeight) >= 768 : true
)

let started = false

function updateFromViewport() {
  if (typeof window === 'undefined') return
  // Fallback to aspect ratio for broader support
  isLandscape.value = window.matchMedia('(orientation: landscape)').matches || window.innerWidth > window.innerHeight || Math.min(window.innerWidth, window.innerHeight) >= 768
}

export function useOrientation() {
  function startOrientationListener() {
    if (started || typeof window === 'undefined') return
    started = true
    const mq = window.matchMedia('(orientation: landscape)')
    const mqHandler = () => updateFromViewport()
    try {
      mq.addEventListener?.('change', mqHandler)
    } catch {
      // Safari fallback (legacy API)
      ;(mq as any).addListener?.(mqHandler)
    }
    window.addEventListener('resize', updateFromViewport)
    window.addEventListener('orientationchange', updateFromViewport)
  }

  async function attemptLockLandscape() {
    try {
      // Some browsers require fullscreen & user gesture. This is best-effort.
      const o: any = (screen as any).orientation || (screen as any).msOrientation || (screen as any).mozOrientation
      const lock = o?.lock as undefined | ((mode: string) => Promise<void>)
      if (typeof lock === 'function') {
        await lock.call(o, 'landscape')
      }
    } catch {
      // Ignore; fallback overlay will prompt rotation
    }
  }

  return {
    isLandscape,
    startOrientationListener,
    attemptLockLandscape
  }
}
